import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import Button from '@rio-cloud/rio-uikit/Button';

import { gaPush } from '@/configuration/setup/googleAnalytics';
import { Criticality, SyncStatus } from './FilterComponent';
import useFetchVehiclesStatusDataCsv, { VehicleStatusDataSectionKey } from './useFetchVehiclesStatusDataCsv';

interface CsvButtonContainerProps {
    criticalityStatus: Criticality[];
    syncStatus: SyncStatus[];
    dataTabsSettings: VehicleStatusDataSectionKey[];
}

const CsvButtonContainer = ({ criticalityStatus, syncStatus, dataTabsSettings }: CsvButtonContainerProps) => {
    const [isDownloading, setIsDownloading] = useState<boolean>(false);
    const { fetchVehiclesStatusDataCsv, vehiclesStatusDataCsv, isLoading } = useFetchVehiclesStatusDataCsv({
        criticalityStatus,
        syncStatus,
        dataTabsSettings,
    });
    const isProcessing = isDownloading || isLoading;

    const handleDownloadCsv = () => {
        setIsDownloading(true);
        const file = new Blob([vehiclesStatusDataCsv!], { type: 'text/csv' });
        const fileURL = URL.createObjectURL(file);
        const tempLink = document.createElement('a');
        tempLink.href = fileURL;
        tempLink.setAttribute('download', 'Export-' + new Date().toISOString().slice(0, 10) + '.csv');
        document.body.appendChild(tempLink);
        tempLink.click();
        document.body.removeChild(tempLink);
        setIsDownloading(false);
    };

    useEffect(() => {
        if (vehiclesStatusDataCsv !== undefined) {
            handleDownloadCsv();
        }
    }, [vehiclesStatusDataCsv]);

    return (
        <div className="display-flex flex-column">
            <Button
                className="margin-top-auto"
                onClick={() => {
                    gaPush({
                        event: 'vs_button_export',
                        parameters: {
                            element_name: 'CsvButtonContainer',
                            component_name: 'Button',
                            trigger: 'click',
                        },
                    });
                    fetchVehiclesStatusDataCsv();
                }}
                disabled={isProcessing}
            >
                {isProcessing && (
                    <span
                        data-testid="csv-loading-spinner"
                        className="rioglyph rioglyph-spinner spinning"
                        aria-hidden="true"
                    />
                )}
                <FormattedMessage id="intl-msg:vehicle_status.csv_button.title" />
            </Button>
        </div>
    );
};

export default CsvButtonContainer;
